import { useSelector } from 'react-redux'

import { Routes, Route, useParams } from 'react-router'

import { RootState } from '../store'

import { HomePage } from '../pages/HomePage'
import { AdministracionPage } from '../pages/admin/AdministracionPage'

import { NotFoundPage } from '../pages/auth/NotFoundPage'

// ---------------------  Administracion  -----------------------------------------------

import { ApiKeysPage } from '../pages/admin/ApiKeysPage'
import { UsuariosPage } from '../pages/admin/UsuariosPage'
import { ConsecutivoPage } from '../pages/admin/ConsecutivoPage'
import { PlantillasPage } from '../pages/admin/PlantillasPage'

// ---------------------  Catalogos  ---------------------------------------------------

import { AsentamientoPage } from '../pages/catalogos/AsentamientoPage'
import { AutoridadAmparoPage } from '../pages/catalogos/AutoridadAmparoPage'
import { AutoridadExhortoLibradoPage } from '../pages/catalogos/AutoridadExhortoLibradoPage'
import { AutoridadExhortoRecibidoPage } from '../pages/catalogos/AutoridadExhortoRecibidoPage'
import { AutoridadPage } from '../pages/catalogos/AutoridadPage'
import { AutoridadResolutoriaPage } from '../pages/catalogos/AutoridadResolutoriaPage'
import { CiudadPage } from '../pages/catalogos/CiudadPage'
import { ClaseDocumentoPage } from '../pages/catalogos/ClaseDocumentoPage'
import { ClaseExhortoPage } from '../pages/catalogos/ClaseExhortoPage'
import { DependenciaPage } from '../pages/catalogos/DependenciaPage'
import { DistritoJudicialPage } from '../pages/catalogos/DistritoJudicialPage'
import { EstadoPage } from '../pages/catalogos/EstadoPage'
import { EstatusPage } from '../pages/catalogos/EstatusPage'
import { EtapaPage } from '../pages/catalogos/EtapaPage'
import { FormaNotificacionPage } from '../pages/catalogos/FormaNotificacionPage'
import { MateriaPage } from '../pages/catalogos/MateriaPage'
import { MunicipioPage } from '../pages/catalogos/MunicipioPage'
import { NacionalidadPage } from '../pages/catalogos/NacionalidadPage'
import { ObjetoExhortoPage } from '../pages/catalogos/ObjetoExhortoPage'
import { PaisPage } from '../pages/catalogos/PaisPage'
import { ProcesoPage } from '../pages/catalogos/ProcesoPage'
import { PuestoPage } from '../pages/catalogos/PuestoPage'
import { RolPage } from '../pages/catalogos/RolPage'
import { SentidoAmparoPage } from '../pages/catalogos/SentidoAmparoPage'
import { SentidoFalloPage } from '../pages/catalogos/SentidoFalloPage'
import { SentidoSentenciaPage } from '../pages/catalogos/SentidoSentenciaPage'
import { SexoPage } from '../pages/catalogos/SexoPage'
import { SubEtapaPage } from '../pages/catalogos/SubEtapaPage'
import { SubTipoAcuerdoPage } from '../pages/catalogos/SubTipoAcuerdoPage'
import { TipoAcuerdoPage } from '../pages/catalogos/TipoAcuerdoPage'
import { TipoAmparoPage } from '../pages/catalogos/TipoAmparoPage'
import { TipoAnexoPage } from '../pages/catalogos/TipoAnexoPage'
import { TipoAsentamientoPage } from '../pages/catalogos/TipoAsentamientoPage'
import { TipoAudienciaPage } from '../pages/catalogos/TipoAudienciaPage'
import { TipoCalificacionPage } from '../pages/catalogos/TipoCalificacionPage'
import { TipoCausaDiferimientoPage } from '../pages/catalogos/TipoCausaDiferimientoPage'
import { TipoConsecutivoPage } from '../pages/catalogos/TipoConsecutivoPage'
import { TipoConvenioPage } from '../pages/catalogos/TipoConvenioPage'
import { TipoDependenciaPage } from '../pages/catalogos/TipoDependenciapage'
import { TipoDocumentoFirmaPage } from '../pages/catalogos/TipoDocumentoFirmaPage'
import { TipoDomicilioPage } from '../pages/catalogos/TipoDomicilioPage'
import { TipoExhortoPage } from '../pages/catalogos/TipoExhortoPage'
import { TipoFormatoPage } from '../pages/catalogos/TipoFormatoPage'
import { TipoIdentificacionPage } from '../pages/catalogos/TipoIdentificacionPage'
import { TipoIrregularPage } from '../pages/catalogos/TipoIrregularPage'
import { TipoJuicioPage } from '../pages/catalogos/TipoJuicioPage'
import { TipoMovimientoPage } from '../pages/catalogos/TipoMovimientoPage'
import { TipoNoCelebracionPage } from '../pages/catalogos/TipoNoCelebracionPage'
import { TipoNotificacionPage } from '../pages/catalogos/TipoNotificacionPage'
import { TipoOficioPage } from '../pages/catalogos/TipoOficioPage'
import { TipoOperacionFirmaPage } from '../pages/catalogos/TipoOperacionFirmaPage'
import { TipoPartePage } from '../pages/catalogos/TipoPartePage'
import { TipoPersonaPage } from '../pages/catalogos/TipoPersonaPage'
import { TipoPrestacionJuicioPage } from '../pages/catalogos/TipoPrestacionJuicioPage'
import { TipoPrestacionPage } from '../pages/catalogos/TipoPrestacionPage'
import { TipoPromocionPage } from '../pages/catalogos/TipoPromocionPage'
import { TipoRecurrentePage } from '../pages/catalogos/TipoRecurrentePage'
import { TipoRecursoPage } from '../pages/catalogos/TipoRecursoPage'
import { TipoReservadoPage } from '../pages/catalogos/TipoReservadoPage'
import { TipoResolucionPage } from '../pages/catalogos/TipoResolucionPage'
import { TipoSentenciaPage } from '../pages/catalogos/TipoSentenciaPage'
import { TipoSesionPage } from '../pages/catalogos/TipoSesionPage'
import { TipoTramitePage } from '../pages/catalogos/TipoTramitePage'
import { TipoUsuarioPage } from '../pages/catalogos/TipoUsuarioPage'
import { UnidadPage } from '../pages/catalogos/UnidadPage'
import { ZonaPage } from '../pages/catalogos/ZonaPage'

// ----------------------------------------  Gestionar acuerdo  ------------------------------------------------

import { CalificarTramitePage } from '../pages/tribunal/gestionar-acuerdo/CalificarTramitePage'
import { ElaborarAcuerdoPage } from '../pages/tribunal/gestionar-acuerdo/ElaborarAcuerdoPage'
import { ValidarAcuerdoPage } from '../pages/tribunal/gestionar-acuerdo/ValidarAcuerdoPage'
import { AutorizarAcuerdoPage } from '../pages/tribunal/gestionar-acuerdo/AutorizarAcuerdoPage'
import { VisualizarAcuerdoPage } from '../pages/tribunal/gestionar-acuerdo/VisualizarAcuerdoPage'

// ----------------------------------------  Gestionar audiencia  ----------------------------------------------

import { CelebrarAudienciaPage } from '../pages/audiencia/gestionar-audiencia/CelebrarAudienciaPage'
import { ElaborarActaAudienciaPage } from '../pages/audiencia/gestionar-audiencia/ElaborarActaAudienciaPage'
import { ValidarActaAudienciaPage } from '../pages/audiencia/gestionar-audiencia/ValidarActaAudienciaPage'
import { AutorizarActaAudienciaPage } from '../pages/audiencia/gestionar-audiencia/AutorizarActaAudienciaPage'
import { VisualizarActaAudienciaPage } from '../pages/audiencia/gestionar-audiencia/VisualizarActaAudienciaPage'

// ---------------------------------------- Gestionar sentencia  -----------------------------------------------

import { ElaborarSentenciaPage } from '../pages/sentencia/gestionar-sentencia/ElaborarSentenciaPage'
import { AutorizarSentenciaPage } from '../pages/sentencia/gestionar-sentencia/AutorizarSentenciaPage'
import { VisualizarSentenciaPage } from '../pages/sentencia/gestionar-sentencia/VisualizarSentenciaPage'

// ----------------------------------------  Gestionar sentencia pública -----------------------------------------------

import { ElaborarSentenciaPublicaPage } from '../pages/sentencia/gestionar-sentencia-publica/ElaborarSentenciaPublicaPage'
import { AutorizarSentenciaPublicaPage } from '../pages/sentencia/gestionar-sentencia-publica/AutorizarSentenciaPublicaPage'
import { VisualizarSentenciaPublicaPage } from '../pages/sentencia/gestionar-sentencia-publica/VisualizarSentenciaPublicaPage'

// ----------------------------------  Gestionar listado de acuerdos  ------------------------------------------

import { GenerarListaAcuerdosPage } from '../pages/tribunal/gestionar-lista-acuerdos/GenerarListaAcuerdosPage'
import { ConsultarListaAcuerdosPage } from '../pages/tribunal/gestionar-lista-acuerdos/ConsultarListaAcuerdosPage'

// ----------------------------------  Gestionar listado de estrados  ------------------------------------------

import { GenerarListaEstradosPage } from '../pages/tribunal/gestionar-lista-estrados/GenerarListaEstradosPage'
import { ConsultarListaEstradosPage } from '../pages/tribunal/gestionar-lista-estrados/ConsultarListaEstradosPage'

// ----------------------------------------  Gestionar Oficio  ---------------------------------------

import { ElaborarOficioPage } from '../pages/tribunal/gestionar-oficio/ElaborarOficioPage'
import { AutorizarOficioPage } from '../pages/tribunal/gestionar-oficio/AutorizarOficioPage'
import { VisualizarOficioPage } from '../pages/tribunal/gestionar-oficio/VisualizarOficioPage'

// ----------------------------------------  Gestionar exhorto librado  ------------------------------

import { ElaborarExhortoLibradoPage } from '../pages/tribunal/gestionar-exhorto-librado/ElaborarExhortoLibradoPage'
import { AutorizarExhortoLibradoPage } from '../pages/tribunal/gestionar-exhorto-librado/AutorizarExhortoLibradoPage'
import { VisualizarExhortoLibradoPage } from '../pages/tribunal/gestionar-exhorto-librado/VisualizarExhortoLibradoPage'

// ----------------------------------------  Generar carátula  ---------------------------------------

import { GenerarCaratulaPage } from '../pages/tribunal/generar-caratula/GenerarCaratulaPage'

// ---------------------------------------- Gestionar listado de envío  ---------------------------------------

import { GenerarListadoEnvioPage } from '../pages/notificacion/gestionar-listado-envio/GenerarListadoEnvioPage'
import { ConsultarListadoEnvioPage } from '../pages/notificacion/gestionar-listado-envio/ConsultarListadoEnvioPage'

// ----------------------------------------  Gestionar certificación  --------------------------------

import { ElaborarCertificacionPage } from '../pages/tribunal/gestionar-certificacion/ElaborarCertificacionPage'
import { VisualizarCertificacionPage } from '../pages/tribunal/gestionar-certificacion/VisualizarCertificacionPage'

// ----------------------------------------  Importación de información  -----------------------------

import { ImportarExpedientePage } from '../pages/tribunal/importar/ImportarExpedientePage'
import { ImportarExhortoPage } from '../pages/tribunal/importar/ImportarExhortoPage'

// ----------------------------------------  Gestionar notificación  ---------------------------------------

import { GenerarNotificacionPage } from '../pages/notificacion/gestionar-notificacion/GenerarNotificacionPage'
import { VisualizarNotificacionPage } from '../pages/notificacion/gestionar-notificacion/VisualizarNotificacionPage'

// -----------------------------------------------  consultas  ---------------------------------------------

import { AcuerdosPendientesPage } from '../pages/consultas/AcuerdosPendientesPage';
import { AgendaAudienciasPage } from '../pages/consultas/AgendaAudienciasPage';
import { CertificacionesPage } from '../pages/consultas/CertificacionesPage';
import { ExhortosLibradosPage } from '../pages/consultas/ExhortosLibradosPage';
import { ExpedientesEtapaProcesalPage } from '../pages/consultas/ExpedientesEtapaProcesalPage';
import { ExpedienteVirtualPage } from '../pages/consultas/ExpedienteVirtualPage';
import { IncidentesPage } from '../pages/consultas/IncidentesPage';
import { NotificacionesPage } from '../pages/consultas/NotificacionesPage';
import { OficiosPage } from '../pages/consultas/OficiosPage';
import { TramitesRecibidosPage } from '../pages/consultas/TramitesRecibidosPage';

// ------------------------------------------  Libros electrónicos  -----------------------------------------

import { LibroRegistroPage } from '../pages/libros-electronicos/LibroRegistroPage';
import { LibroAuxiliarPage } from '../pages/libros-electronicos/LibroAuxiliarPage';
import { LibroAmparosPage } from '../pages/libros-electronicos/LibroAmparosPage';
import { LibroExhortosLibradosPage } from '../pages/libros-electronicos/LibroExhortosLibradosPage';
import { LibroExhortosRecibidosPage } from '../pages/libros-electronicos/LibroExhortosRecibidosPage';
import { LibroActuariosPage } from '../pages/libros-electronicos/LibroActuariosPage';
import { LibroExpedientesConcluidosPage } from '../pages/libros-electronicos/LibroExpedientesConcluidosPage';
import { LibroCitadosSentenciaDefinitivaPage } from '../pages/libros-electronicos/LibroCitadosSentenciaDefinitivaPage';
import { LibroCitadosSentenciaInterlocutoriaPage } from '../pages/libros-electronicos/LibroCitadosSentenciaInterlocutoriaPage';
import { LibroPromocionesRecibidasPage } from '../pages/libros-electronicos/LibroPromocionesRecibidasPage';
import { LibroIndiceAlfabeticoPage } from '../pages/libros-electronicos/LibroIndiceAlfabeticoPage';
import { LibroMediosImpugnacionPage } from '../pages/libros-electronicos/LibroMediosImpugnacionPage';
import { SubirRazonamientoPage } from '../pages/notificacion/gestionar-notificacion/SubirRazonamientoPage'
import { DigitalizarAnexosPage } from '../pages/audiencia/gestionar-audiencia/DigitalizarAnexosPage'
import { AdministracionCasosPage } from '../pages/admin/AdministracionCasosPage';

const WithKey = ({ Component }: { Component: React.ComponentType }) => {

    const { Id } = useParams();

    return <Component key={ Id } />;
};

export const SAJIRoutes = () => {

    const { administrador, coordinador, token } = useSelector( ( state: RootState ) => state.auth );

    return (

        <Routes>

            {
                administrador
                ?
                    <>
                    
                        <Route path='/' element={ <AdministracionPage /> } />   

                        {/* ------------------------------  Administracion  ----------------------------------------------- */}
                        
                        <Route path='/administracion/usuarios/' element={ <UsuariosPage /> } />   
            
                        <Route path='/administracion/apikeys/' element={ <ApiKeysPage /> } />    

                        <Route path='/administracion/consecutivo/' element={ <ConsecutivoPage /> } />  
                        
                        <Route path='/administracion/plantillas/' element={ <PlantillasPage /> } />      

                        <Route path='/administracion/administracion-casos/' element={ <AdministracionCasosPage /> } />          

                        {/* -------------------------------  Catalogos  -------------------------------------------------- */}
                                                                   
                        <Route path='/administracion/catalogos/asentamiento/' element={ <AsentamientoPage /> } />       
                        
                        <Route path='/administracion/catalogos/autoridad/' element={ <AutoridadPage /> } />       
                        
                        <Route path='/administracion/catalogos/autoridad-amparo/' element={ <AutoridadAmparoPage /> } />       
                        
                        <Route path='/administracion/catalogos/autoridad-exhorto-recibido/' element={ <AutoridadExhortoRecibidoPage /> } />       
                        
                        <Route path='/administracion/catalogos/autoridad-exhorto-librado/' element={ <AutoridadExhortoLibradoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/autoridad-resolutoria/' element={ <AutoridadResolutoriaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/ciudad/' element={ <CiudadPage /> } />       
                        
                        <Route path='/administracion/catalogos/clase-documento/' element={ <ClaseDocumentoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/clase-exhorto/' element={ <ClaseExhortoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/dependencia/' element={ <DependenciaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/distrito-judicial/' element={ <DistritoJudicialPage /> } />       
                        
                        <Route path='/administracion/catalogos/estado/' element={ <EstadoPage/> } />       
                        
                        <Route path='/administracion/catalogos/estatus/' element={ <EstatusPage/> } />       
                        
                        <Route path='/administracion/catalogos/etapa/' element={ <EtapaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/forma-notificacion/' element={ <FormaNotificacionPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/materia/' element={ <MateriaPage/> } />       
                        
                        <Route path='/administracion/catalogos/municipio/' element={ <MunicipioPage /> } />       
                        
                        <Route path='/administracion/catalogos/nacionalidad/' element={ <NacionalidadPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/objeto-exhorto/' element={ <ObjetoExhortoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/pais/' element={ <PaisPage /> } />       
                        
                        <Route path='/administracion/catalogos/proceso/' element={ <ProcesoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/puesto/' element={ <PuestoPage /> } />     
                        
                        <Route path='/administracion/catalogos/rol/' element={ <RolPage /> } />                        
                        
                        <Route path='/administracion/catalogos/sentido-amparo/' element={ <SentidoAmparoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/sentido-fallo/' element={ <SentidoFalloPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/sentido-sentencia/' element={ <SentidoSentenciaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/sexo/' element={ <SexoPage /> } />                        
                        
                        <Route path='/administracion/catalogos/sub-etapa/' element={ <SubEtapaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/sub-tipo-acuerdo/' element={ <SubTipoAcuerdoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-acuerdo/' element={ <TipoAcuerdoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-amparo/' element={ <TipoAmparoPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-anexo/' element={ <TipoAnexoPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-asentamiento/' element={ <TipoAsentamientoPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-audiencia/' element={ <TipoAudienciaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-calificacion/' element={ <TipoCalificacionPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-causa-diferimiento/' element={ <TipoCausaDiferimientoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-consecutivo/' element={ <TipoConsecutivoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-convenio/' element={ <TipoConvenioPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-dependencia/' element={ <TipoDependenciaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-documento-firma/' element={ <TipoDocumentoFirmaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-domicilio/' element={ <TipoDomicilioPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-exhorto/' element={ <TipoExhortoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-formato/' element={ <TipoFormatoPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-identificacion/' element={ <TipoIdentificacionPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-irregular/' element={ <TipoIrregularPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-juicio/' element={ <TipoJuicioPage /> } />                
                        
                        <Route path='/administracion/catalogos/tipo-movimiento/' element={ <TipoMovimientoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-no-celebracion/' element={ <TipoNoCelebracionPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-notificacion/' element={ <TipoNotificacionPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-oficio/' element={ <TipoOficioPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-operacion-firma/' element={ <TipoOperacionFirmaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-parte/' element={ <TipoPartePage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-persona/' element={ <TipoPersonaPage /> } />      
                        
                        <Route path='/administracion/catalogos/tipo-prestacion/' element={ <TipoPrestacionPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-prestacionJuicio/' element={ <TipoPrestacionJuicioPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-promocion/' element={ <TipoPromocionPage /> } />      
                        
                        <Route path='/administracion/catalogos/tipo-recurrente/' element={ <TipoRecurrentePage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-recurso/' element={ <TipoRecursoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-reservado/' element={ <TipoReservadoPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-resolucion/' element={ <TipoResolucionPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-sentencia/' element={ <TipoSentenciaPage /> } />                                  
                        
                        <Route path='/administracion/catalogos/tipo-sesion/' element={ <TipoSesionPage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-tramite/' element={ <TipoTramitePage /> } />                        
                        
                        <Route path='/administracion/catalogos/tipo-usuario/' element={ <TipoUsuarioPage/> } />                        
                        
                        <Route path='/administracion/catalogos/unidad/' element={ <UnidadPage /> } />   
                                                       
                        <Route path='/administracion/catalogos/zona/' element={ <ZonaPage /> } />     

                        {/* --------------------------------------  Consultas  --------------------------------------------- */}
                        
                        <Route path='/consultas/expediente-virtual/' element={ <ExpedienteVirtualPage /> } />
                        
                        <Route path='/consultas/agenda-audiencias/' element={ <AgendaAudienciasPage /> } />
                        
                        <Route path='/consultas/tramites-recibidos/' element={ <TramitesRecibidosPage /> } />
                        
                        <Route path='/consultas/acuerdos-pendientes/' element={ <AcuerdosPendientesPage /> } />
                        
                        <Route path='/consultas/oficios/' element={ <OficiosPage /> } />
                        
                        <Route path='/consultas/exhortos-librados/' element={ <ExhortosLibradosPage /> } />
                        
                        <Route path='/consultas/notificaciones/' element={ <NotificacionesPage /> } />
                        
                        <Route path='/consultas/expedientes-por-etapa-procesal/' element={ <ExpedientesEtapaProcesalPage /> } />
                        
                        <Route path='/consultas/incidentes/' element={ <IncidentesPage /> } />
                        
                        <Route path='/consultas/certificaciones/' element={ <CertificacionesPage /> } />

                        {/* ----------------------------------  libros electrónicos  ---------------------------------------- */}

                        <Route path='/libros-electronicos/libro-registro/' element={ <LibroRegistroPage /> } />

                        <Route path='/libros-electronicos/libro-auxiliar/' element={ <LibroAuxiliarPage /> } />

                        <Route path='/libros-electronicos/libro-amparos/' element={ <LibroAmparosPage /> } />

                        <Route path='/libros-electronicos/libro-exhortos-librados/' element={ <LibroExhortosLibradosPage /> } />

                        <Route path='/libros-electronicos/libro-exhortos-recibidos/' element={ <LibroExhortosRecibidosPage /> } />

                        <Route path='/libros-electronicos/libro-actuarios/' element={ <LibroActuariosPage /> } />

                        <Route path='/libros-electronicos/libro-expedientes-concluidos/' element={ <LibroExpedientesConcluidosPage /> } />

                        <Route path='/libros-electronicos/libro-citados-sentencia-definitiva/' element={ <LibroCitadosSentenciaDefinitivaPage /> } />

                        <Route path='/libros-electronicos/libro-citados-sentencia-interlocutoria/' element={ <LibroCitadosSentenciaInterlocutoriaPage /> } />

                        <Route path='/libros-electronicos/libro-promociones-recibidas/' element={ <LibroPromocionesRecibidasPage /> } />

                        <Route path='/libros-electronicos/libro-indice-alfabetico/' element={ <LibroIndiceAlfabeticoPage /> } />
                        
                        <Route path='/libros-electronicos/libro-medios-impugnacion/' element={ <LibroMediosImpugnacionPage /> } />   

                    </>
                :
                
                    coordinador
                    ?

                        <>
                    
                            <Route path='/' element={ <HomePage /> } />

                            {/* ------------------------------  Administracion  ----------------------------------------------- */}

                            <Route path='/administracion/administracion-casos/' element={ <AdministracionCasosPage /> } />       
                        
                            <Route path='/administracion/plantillas/' element={ <PlantillasPage /> } />      

                            {/* -------------------------------  Catalogos  -------------------------------------------------- */}

                            <Route path='/administracion/catalogos/autoridad-exhorto-recibido/' element={ <AutoridadExhortoRecibidoPage /> } />       
                            
                            {/* --------------------------------  Gestionar acuerdo  ------------------------------------------ */}

                            <Route path='/tribunal/acuerdo/calificar-tramite/:Id' element={ <WithKey Component={ CalificarTramitePage } /> } />

                            <Route path='/tribunal/acuerdo/elaborar/:Id' element={ <WithKey Component={ ElaborarAcuerdoPage } /> } />

                            <Route path='/tribunal/acuerdo/validar/:Id' element={ <WithKey Component={ ValidarAcuerdoPage } /> } />

                            <Route path='/tribunal/acuerdo/autorizar/:Id' element={ <WithKey Component={ AutorizarAcuerdoPage } /> } />

                            <Route path='/tribunal/acuerdo/visualizar/:Id' element={ <WithKey Component={ VisualizarAcuerdoPage } /> } />

                            {/* --------------------------------  Gestionar audiencia  ------------------------------------------ */}

                            <Route path='/gestionar-audiencia/celebrar-audiencia/:Id' element={ <WithKey Component={ CelebrarAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/elaborar-acta/:Id' element={ <WithKey Component={ ElaborarActaAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/validar-acta/:Id' element={ <WithKey Component={ ValidarActaAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/autorizar-acta/:Id' element={ <WithKey Component={ AutorizarActaAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/visualizar-acta/:Id' element={ <WithKey Component={ VisualizarActaAudienciaPage } /> } />
                            
                            <Route path='/gestionar-audiencia/escanear-anexos/:Id' element={ <WithKey Component={ DigitalizarAnexosPage } /> } />

                            {/* --------------------------------  Gestionar sentencia  ------------------------------------------ */}

                            <Route path='/sentencia/elaborar/:Id' element={ <WithKey Component={ ElaborarSentenciaPage } /> } />

                            <Route path='/sentencia/autorizar/:Id' element={ <WithKey Component={ AutorizarSentenciaPage } /> } />
                            
                            <Route path='/sentencia/visualizar/:Id' element={ <WithKey Component={ VisualizarSentenciaPage } /> } />

                            {/* --------------------------------  Gestionar sentencia pública ------------------------------------------ */}

                            <Route path='/sentencia-publica/elaborar/:Id' element={ <WithKey Component={ ElaborarSentenciaPublicaPage } /> } />

                            <Route path='/sentencia-publica/autorizar/:Id' element={ <WithKey Component={ AutorizarSentenciaPublicaPage } /> } />
                            
                            <Route path='/sentencia-publica/visualizar/:Id' element={ <WithKey Component={ VisualizarSentenciaPublicaPage } /> } />

                            {/* ---------------------------------  Lista de acuerdos  ----------------------------------------- */}

                            <Route path='/tribunal/lista-acuerdos/generar/:Id' element={ <WithKey Component={ GenerarListaAcuerdosPage } /> } />

                            <Route path='/tribunal/lista-acuerdos/consultar/' element={ <ConsultarListaAcuerdosPage /> } />

                            {/* ---------------------------------  Lista de estrados  ----------------------------------------- */}

                            <Route path='/tribunal/lista-estrados/generar/:Id' element={ <WithKey Component={ GenerarListaEstradosPage } /> } />

                            <Route path='/tribunal/lista-estrados/consultar/' element={ <ConsultarListaEstradosPage /> } />
                            

                            {/* --------------------------------  Gestionar oficio  ------------------------------------------ */}

                            <Route path='/tribunal/oficio/elaborar/:Id' element={ <WithKey Component={ ElaborarOficioPage } /> } />

                            <Route path='/tribunal/oficio/autorizar/:Id' element={ <WithKey Component={ AutorizarOficioPage } /> } />
                            
                            <Route path='/tribunal/oficio/visualizar/:Id' element={ <WithKey Component={ VisualizarOficioPage } /> } />

                            {/* -----------------------------  Gestionar exhorto librado  ------------------------------------ */}

                            <Route path='/tribunal/exhorto-librado/elaborar/:Id' element={ <WithKey Component={ ElaborarExhortoLibradoPage } /> } />

                            <Route path='/tribunal/exhorto-librado/autorizar/:Id' element={ <WithKey Component={ AutorizarExhortoLibradoPage } /> } />
                            
                            <Route path='/tribunal/exhorto-librado/visualizar/:Id' element={ <WithKey Component={ VisualizarExhortoLibradoPage } /> } />
                            
                            {/* ---------------------------------  Generar carátula  ----------------------------------------- */}

                            <Route path='/tribunal/caratula/generar/' element={ <GenerarCaratulaPage /> } />

                            {/* ------------------------------  Gestionar certificación  ------------------------------------- */}

                            <Route path='/tribunal/certificacion/elaborar/:Id' element={ <WithKey Component={ ElaborarCertificacionPage } /> } />

                            <Route path='/tribunal/certificacion/visualizar/:Id' element={ <WithKey Component={ VisualizarCertificacionPage } /> } />
                            
                            {/* -----------------------------  Importación de información  ----------------------------------- */}

                            <Route path='/tribunal/importar/expediente/' element={ <ImportarExpedientePage /> } />

                            <Route path='/tribunal/importar/exhorto/' element={ <ImportarExhortoPage /> } />
                            
                            {/* ------------------------------  Gestionar notificación  --------------------------------------- */}

                            <Route path='/notificacion/generar/:Id' element={ <WithKey Component={ GenerarNotificacionPage } /> } />

                            <Route path='/notificacion/visualizar/:Id' element={ <WithKey Component={ VisualizarNotificacionPage } /> } />

                            <Route path='/notificacion/subir-razonamiento/:Id'  element={ <WithKey Component={ SubirRazonamientoPage } /> } />
                            
                            {/* ---------------------------------  Listado de envío  ----------------------------------------- */}

                            <Route path='/listado-envio/generar/:Id' element={ <WithKey Component={ GenerarListadoEnvioPage } /> } />

                            <Route path='/listado-envio/consultar/' element={ <ConsultarListadoEnvioPage /> } />

                            {/* --------------------------------------  Consultas  --------------------------------------------- */}
                            
                            <Route path='/consultas/expediente-virtual/' element={ <ExpedienteVirtualPage /> } />
                            
                            <Route path='/consultas/agenda-audiencias/' element={ <AgendaAudienciasPage /> } />
                            
                            <Route path='/consultas/tramites-recibidos/' element={ <TramitesRecibidosPage /> } />
                            
                            <Route path='/consultas/acuerdos-pendientes/' element={ <AcuerdosPendientesPage /> } />
                            
                            <Route path='/consultas/oficios/' element={ <OficiosPage /> } />
                            
                            <Route path='/consultas/exhortos-librados/' element={ <ExhortosLibradosPage /> } />
                            
                            <Route path='/consultas/notificaciones/' element={ <NotificacionesPage /> } />
                            
                            <Route path='/consultas/expedientes-por-etapa-procesal/' element={ <ExpedientesEtapaProcesalPage /> } />
                            
                            <Route path='/consultas/incidentes/' element={ <IncidentesPage /> } />
                            
                            <Route path='/consultas/certificaciones/' element={ <CertificacionesPage /> } />

                            {/* ----------------------------------  libros electrónicos  ---------------------------------------- */}

                            <Route path='/libros-electronicos/libro-registro/' element={ <LibroRegistroPage /> } />

                            <Route path='/libros-electronicos/libro-auxiliar/' element={ <LibroAuxiliarPage /> } />

                            <Route path='/libros-electronicos/libro-amparos/' element={ <LibroAmparosPage /> } />

                            <Route path='/libros-electronicos/libro-exhortos-librados/' element={ <LibroExhortosLibradosPage /> } />

                            <Route path='/libros-electronicos/libro-exhortos-recibidos/' element={ <LibroExhortosRecibidosPage /> } />

                            <Route path='/libros-electronicos/libro-actuarios/' element={ <LibroActuariosPage /> } />

                            <Route path='/libros-electronicos/libro-expedientes-concluidos/' element={ <LibroExpedientesConcluidosPage /> } />

                            <Route path='/libros-electronicos/libro-citados-sentencia-definitiva/' element={ <LibroCitadosSentenciaDefinitivaPage /> } />

                            <Route path='/libros-electronicos/libro-citados-sentencia-interlocutoria/' element={ <LibroCitadosSentenciaInterlocutoriaPage /> } />

                            <Route path='/libros-electronicos/libro-promociones-recibidas/' element={ <LibroPromocionesRecibidasPage /> } />

                            <Route path='/libros-electronicos/libro-indice-alfabetico/' element={ <LibroIndiceAlfabeticoPage /> } />
                            
                            <Route path='/libros-electronicos/libro-medios-impugnacion/' element={ <LibroMediosImpugnacionPage /> } />

                        </>

                    :

                        <>
                        
                            <Route path='/' element={ <HomePage /> } />

                            {/* -------------------------------  Catalogos  -------------------------------------------------- */}

                            <Route path='/administracion/catalogos/autoridad-exhorto-recibido/' element={ <AutoridadExhortoRecibidoPage /> } />       
                            
                            {/* --------------------------------  Gestionar acuerdo  ------------------------------------------ */}

                            <Route path='/tribunal/acuerdo/calificar-tramite/:Id' element={ <WithKey Component={ CalificarTramitePage } /> } />

                            <Route path='/tribunal/acuerdo/elaborar/:Id' element={ <WithKey Component={ ElaborarAcuerdoPage } /> } />

                            <Route path='/tribunal/acuerdo/validar/:Id' element={ <WithKey Component={ ValidarAcuerdoPage } /> } />

                            <Route path='/tribunal/acuerdo/autorizar/:Id' element={ <WithKey Component={ AutorizarAcuerdoPage } /> } />

                            <Route path='/tribunal/acuerdo/visualizar/:Id' element={ <WithKey Component={ VisualizarAcuerdoPage } /> } />

                            {/* --------------------------------  Gestionar audiencia  ------------------------------------------ */}

                            <Route path='/gestionar-audiencia/celebrar-audiencia/:Id' element={ <WithKey Component={ CelebrarAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/elaborar-acta/:Id' element={ <WithKey Component={ ElaborarActaAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/validar-acta/:Id' element={ <WithKey Component={ ValidarActaAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/autorizar-acta/:Id' element={ <WithKey Component={ AutorizarActaAudienciaPage } /> } />

                            <Route path='/gestionar-audiencia/visualizar-acta/:Id' element={ <WithKey Component={ VisualizarActaAudienciaPage } /> } />
                            
                            <Route path='/gestionar-audiencia/escanear-anexos/:Id' element={ <WithKey Component={ DigitalizarAnexosPage } /> } />

                            {/* --------------------------------  Gestionar sentencia  ------------------------------------------ */}

                            <Route path='/sentencia/elaborar/:Id' element={ <WithKey Component={ ElaborarSentenciaPage } /> } />

                            <Route path='/sentencia/autorizar/:Id' element={ <WithKey Component={ AutorizarSentenciaPage } /> } />
                            
                            <Route path='/sentencia/visualizar/:Id' element={ <WithKey Component={ VisualizarSentenciaPage } /> } />

                            {/* --------------------------------  Gestionar sentencia pública ------------------------------------------ */}

                            <Route path='/sentencia-publica/elaborar/:Id' element={ <WithKey Component={ ElaborarSentenciaPublicaPage } /> } />

                            <Route path='/sentencia-publica/autorizar/:Id' element={ <WithKey Component={ AutorizarSentenciaPublicaPage } /> } />
                            
                            <Route path='/sentencia-publica/visualizar/:Id' element={ <WithKey Component={ VisualizarSentenciaPublicaPage } /> } />

                            {/* ---------------------------------  Lista de acuerdos  ----------------------------------------- */}

                            <Route path='/tribunal/lista-acuerdos/generar/:Id' element={ <WithKey Component={ GenerarListaAcuerdosPage } /> } />

                            <Route path='/tribunal/lista-acuerdos/consultar/' element={ <ConsultarListaAcuerdosPage /> } />

                            {/* ---------------------------------  Lista de estrados  ----------------------------------------- */}

                            <Route path='/tribunal/lista-estrados/generar/:Id' element={ <WithKey Component={ GenerarListaEstradosPage } /> } />

                            <Route path='/tribunal/lista-estrados/consultar/' element={ <ConsultarListaEstradosPage /> } />
                            

                            {/* --------------------------------  Gestionar oficio  ------------------------------------------ */}

                            <Route path='/tribunal/oficio/elaborar/:Id' element={ <WithKey Component={ ElaborarOficioPage } /> } />

                            <Route path='/tribunal/oficio/autorizar/:Id' element={ <WithKey Component={ AutorizarOficioPage } /> } />
                            
                            <Route path='/tribunal/oficio/visualizar/:Id' element={ <WithKey Component={ VisualizarOficioPage } /> } />

                            {/* -----------------------------  Gestionar exhorto librado  ------------------------------------ */}

                            <Route path='/tribunal/exhorto-librado/elaborar/:Id' element={ <WithKey Component={ ElaborarExhortoLibradoPage } /> } />

                            <Route path='/tribunal/exhorto-librado/autorizar/:Id' element={ <WithKey Component={ AutorizarExhortoLibradoPage } /> } />
                            
                            <Route path='/tribunal/exhorto-librado/visualizar/:Id' element={ <WithKey Component={ VisualizarExhortoLibradoPage } /> } />
                            
                            {/* ---------------------------------  Generar carátula  ----------------------------------------- */}

                            <Route path='/tribunal/caratula/generar/' element={ <GenerarCaratulaPage /> } />

                            {/* ------------------------------  Gestionar certificación  ------------------------------------- */}

                            <Route path='/tribunal/certificacion/elaborar/:Id' element={ <WithKey Component={ ElaborarCertificacionPage } /> } />

                            <Route path='/tribunal/certificacion/visualizar/:Id' element={ <WithKey Component={ VisualizarCertificacionPage } /> } />
                            
                            {/* -----------------------------  Importación de información  ----------------------------------- */}

                            <Route path='/tribunal/importar/expediente/' element={ <ImportarExpedientePage /> } />

                            <Route path='/tribunal/importar/exhorto/' element={ <ImportarExhortoPage /> } />
                            
                            {/* ------------------------------  Gestionar notificación  --------------------------------------- */}

                            <Route path='/notificacion/generar/:Id' element={ <WithKey Component={ GenerarNotificacionPage } /> } />

                            <Route path='/notificacion/visualizar/:Id' element={ <WithKey Component={ VisualizarNotificacionPage } /> } />

                            <Route path='/notificacion/subir-razonamiento/:Id'  element={ <WithKey Component={ SubirRazonamientoPage } /> } />
                            
                            {/* ---------------------------------  Listado de envío  ----------------------------------------- */}

                            <Route path='/listado-envio/generar/:Id' element={ <WithKey Component={ GenerarListadoEnvioPage } /> } />

                            <Route path='/listado-envio/consultar/' element={ <ConsultarListadoEnvioPage /> } />

                            {/* --------------------------------------  Consultas  --------------------------------------------- */}
                            
                            <Route path='/consultas/expediente-virtual/' element={ <ExpedienteVirtualPage /> } />
                            
                            <Route path='/consultas/agenda-audiencias/' element={ <AgendaAudienciasPage /> } />
                            
                            <Route path='/consultas/tramites-recibidos/' element={ <TramitesRecibidosPage /> } />
                            
                            <Route path='/consultas/acuerdos-pendientes/' element={ <AcuerdosPendientesPage /> } />
                            
                            <Route path='/consultas/oficios/' element={ <OficiosPage /> } />
                            
                            <Route path='/consultas/exhortos-librados/' element={ <ExhortosLibradosPage /> } />
                            
                            <Route path='/consultas/notificaciones/' element={ <NotificacionesPage /> } />
                            
                            <Route path='/consultas/expedientes-por-etapa-procesal/' element={ <ExpedientesEtapaProcesalPage /> } />
                            
                            <Route path='/consultas/incidentes/' element={ <IncidentesPage /> } />
                            
                            <Route path='/consultas/certificaciones/' element={ <CertificacionesPage /> } />

                            {/* ----------------------------------  libros electrónicos  ---------------------------------------- */}

                            <Route path='/libros-electronicos/libro-registro/' element={ <LibroRegistroPage /> } />

                            <Route path='/libros-electronicos/libro-auxiliar/' element={ <LibroAuxiliarPage /> } />

                            <Route path='/libros-electronicos/libro-amparos/' element={ <LibroAmparosPage /> } />

                            <Route path='/libros-electronicos/libro-exhortos-librados/' element={ <LibroExhortosLibradosPage /> } />

                            <Route path='/libros-electronicos/libro-exhortos-recibidos/' element={ <LibroExhortosRecibidosPage /> } />

                            <Route path='/libros-electronicos/libro-actuarios/' element={ <LibroActuariosPage /> } />

                            <Route path='/libros-electronicos/libro-expedientes-concluidos/' element={ <LibroExpedientesConcluidosPage /> } />

                            <Route path='/libros-electronicos/libro-citados-sentencia-definitiva/' element={ <LibroCitadosSentenciaDefinitivaPage /> } />

                            <Route path='/libros-electronicos/libro-citados-sentencia-interlocutoria/' element={ <LibroCitadosSentenciaInterlocutoriaPage /> } />

                            <Route path='/libros-electronicos/libro-promociones-recibidas/' element={ <LibroPromocionesRecibidasPage /> } />

                            <Route path='/libros-electronicos/libro-indice-alfabetico/' element={ <LibroIndiceAlfabeticoPage /> } />
                            
                            <Route path='/libros-electronicos/libro-medios-impugnacion/' element={ <LibroMediosImpugnacionPage /> } />

                        </>
            }

            { token && <Route path='*' element={ <NotFoundPage /> } /> }                       

        </Routes>        
    
    )
}